const mapCustomTemplates = list =>
  list.reduce(
    (map, customTemplate) => ({ ...map, [customTemplate.id]: { ...customTemplate } }),
    {}
  );

export default { mapCustomTemplates };
